import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import styles from "./Calendar.module.css";


const options = ['Termin', 'Urlaub'];

interface ICalendarOptionsButton {
    setCreateAppointmentOpen?: Dispatch<SetStateAction<boolean>>
    setCreateHolidayRequestOpen?: Dispatch<SetStateAction<boolean>>
}

function CalendarOptionsButton({ setCreateAppointmentOpen, setCreateHolidayRequestOpen }: ICalendarOptionsButton) {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const handleClick = () => {

        switch (options[selectedIndex]) {
            case "Termin":
                if (setCreateAppointmentOpen) {
                    setCreateAppointmentOpen(true);
                }
                break;
            case "Urlaub":
                if (setCreateHolidayRequestOpen) {
                    setCreateHolidayRequestOpen(true);
                }
                break;
            default:
                console.log(`You clicked ${options[selectedIndex]}`);
                break;
        }

    };

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLLIElement, MouseEvent>,
        index: number,
    ) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setOpen(false);
    };

    return (
        <div className='flex w-[60%]'>
            <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button" className={styles.buttonGroupRadius}>
                <Button onClick={handleClick} className={styles.groupOptionsButton.concat(" " + styles.createAppointment)} startIcon={<AddCircleRoundedIcon style={{ color: "var(--brand)" }} />}>
                    {options[selectedIndex]}
                </Button>
                <Button
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                    variant="outlined"
                    className={styles.groupToggleButton.concat(" " + styles.createAppointment)}
                >
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Popper
                sx={{
                    zIndex: 1,
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            key={option}
                                            disabled={index === 2}
                                            selected={index === selectedIndex}
                                            onClick={(event) => handleMenuItemClick(event, index)}
                                        >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
}

export default CalendarOptionsButton